import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '@api-client/types';
import {
  DocumentTemplatesInterface,
  DatapointsInterface
} from '@interfaces/DocumentTemplates.interface';
import { PolicyInterface } from '@interfaces/Policy.interface';
import { AxiosPromise } from 'axios';

export class ApiDocumentTemplates extends BaseApiClient {
  async all(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<DocumentTemplatesInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/document-templates', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta.current_page,
                perPage: res.data.meta.per_page,
                total: res.data.meta.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async store(
    body: DocumentTemplatesInterface
  ): Promise<DocumentTemplatesInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/document-templates', body)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async update(
    id: number | undefined,
    body: DocumentTemplatesInterface
  ): Promise<DocumentTemplatesInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/document-templates/${id}`, body)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async use(
    id: number | undefined,
    body: DocumentTemplatesInterface
  ): Promise<DocumentTemplatesInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/document-templates/use/${id}`, body)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getQuotesAndInvoices(
    body: DocumentTemplatesInterface
  ): Promise<DocumentTemplatesInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/document-templates/get-quotes-and-invoices', body)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async policies(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<PolicyInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.policyKeywordAll = searchTerm;
      }
      this.client
        .getList('/policies', listData)
        .then(({ data }) => {
          if (data) {
            resolve({
              items: data.data,
              pagination: {
                page: data.meta?.page,
                perPage: data.meta?.per_page,
                total: data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  delete(id: number | undefined): AxiosPromise<true> {
    return new Promise((resolve) => {
      this.client
        .delete(`/document-templates?document_template_ids=${id}`)
        .then((res) => resolve(res))
        .catch(console.error);
    });
  }

  async datapoints(): Promise<DatapointsInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/document-templates/datapoints')
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { documentTemplatesQueryKeys } from './query-keys';
export type {
  DocumentTemplatesListParams,
  DocumentTemplatesPoliciesListParams
} from './query-keys';
export {
  useDocumentTemplatesDatapointsQuery,
  useDocumentTemplatesListQuery,
  useDocumentTemplatesPoliciesQuery
} from './use-document-templates-queries';
export {
  useDocumentTemplatesApplyMutation,
  useDocumentTemplatesDeleteMutation,
  useDocumentTemplatesGetQuotesAndInvoicesMutation,
  useDocumentTemplatesStoreMutation,
  useDocumentTemplatesUpdateMutation
} from './use-document-templates-mutations';

